import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.timers.js";
/**
 * Check if current device is a touch device
 * @returns {Boolean}
 */
export function isTouchDevice() {
  return window && window.matchMedia && window.matchMedia("(pointer: coarse)").matches;
}

/**
 * Return a value bettween min an max
 * @param {number} value
 * @param {number} min
 * @param {number} max
 * @returns {number}
 */
export function getMinMax() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Infinity;
  var newValue = value;
  newValue = Math.max(newValue, min);
  newValue = Math.min(newValue, max);
  return newValue;
}

/**
 * function makes sure that your code is only triggered once per user input
 * @param {function} action
 * @param {number} delay in ms (default 200ms)
 * @returns {function}
 */
export function debounce(action, delay) {
  var timeout;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return clearTimeout(timeout, setTimeout.apply(void 0, [action, delay].concat(args)));
  };
}